import React, { useEffect, useState } from 'react';
import CVGauge from './CVGauge';

const SOURCES = [
  '2Seam',
  '4SeamLower',
  '4SeamA',
  '4SeamUpper',
  'MixedOversize',
  'Rewash Coal',
];

function YieldGauges({ range = '7d', start, end }) {
  const [values, setValues] = useState({});

  useEffect(() => {
    const srcParam = SOURCES.map(encodeURIComponent).join(',');
    const params = start && end
      ? `start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}`
      : `time_range=${range}`;
    fetch(`/api/source-yield.php?${params}&sources=${srcParam}`)
      .then(res => res.json())
      .then(res => {
        const obj = {};
        (res || []).forEach(r => {
          obj[r.source] = r.yield_percent;
        });
        setValues(obj);
      })
      .catch(() => setValues({}));
  }, [range, start, end]);

  const targets = {
    '2Seam': 65,
    '4SeamLower': 46,
    '4SeamA': 60,
    '4SeamUpper': 50,
    'MixedOversize': 60,
    'Rewash Coal': 30,
  };

  return (
    <div className="mt-4 flex-1 space-y-2">
      <div className="grid grid-cols-7 gap-4 items-end">
        <div className="flex items-center justify-center text-[12px] font-semibold">
          Current
        </div>
        {SOURCES.map(src => (
          <CVGauge
            key={src}
            source={src}
            value={values[src] || 0}
            thresholds={[0, 100]}
            showSideLabels={false}
            gradient
            gradientStops={['#dc2626', '#f59e0b', '#22c55e']}
          />
        ))}
      </div>
      <div className="grid grid-cols-7 gap-4 items-center">
        <div className="flex items-center justify-center text-[12px] font-semibold">
          Target
        </div>
        {SOURCES.map(src => (
          <div key={src} className="flex items-center justify-center">
            <span className="px-1.5 py-0.5 rounded-full text-white text-[12px] font-semibold" style={{ backgroundColor: '#21C55E' }}>
              {targets[src]}%
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default YieldGauges;
